export function setAdvtState<
  TKey extends keyof NonNullable<typeof window.ADVT>
>(key: TKey, value: NonNullable<typeof window.ADVT>[TKey]): void {
  if (typeof window === 'undefined') return;

  window.ADVT ??= {} as NonNullable<typeof window.ADVT>;
  window.ADVT[key] = value;
}
